<template>
  <div v-if="player">
    <!-- title -->
    <p class="title is-4 is-spaced">{{ player.username }}</p>

    <!-- tabs -->
    <div class="tabs is-boxed">
      <ul>
        <router-link :to="{ name: 'player' }" active-class="is-active" tag="li" exact><a>{{"player.tabs.general" | translate}}</a></router-link>
        <router-link :to="{ name: 'player-transactions' }" active-class="is-active" tag="li"><a>{{"player.tabs.transactions" | translate}}</a></router-link>
        <router-link :to="{ name: 'player-pins' }" active-class="is-active" tag="li"><a>{{"player.tabs.pins" | translate}}</a></router-link>
        <router-link :to="{ name: 'player-redpipe-bets' }" active-class="is-active" tag="li"><a>{{"player.tabs.redpipe bets" | translate}}</a></router-link>
        <router-link :to="{ name: 'player-flg-bets' }" active-class="is-active" tag="li"><a>{{"player.tabs.flg bets" | translate}}</a></router-link>
        <router-link :to="{ name: 'player-hdraces-bets' }" active-class="is-active" tag="li"><a>{{"player.tabs.hdraces bets" | translate}}</a></router-link>
        <router-link :to="{ name: 'player-bk-bets' }" active-class="is-active" tag="li"><a>{{"player.tabs.bk bets" | translate}}</a></router-link>
      </ul>
    </div>

    <router-view />
  </div>
</template>
<script>
  import state from '../../../../state'
  import playerService from '../../../../services/player.service'
  import breadcrumbsService from '../../../../services/breadcrumbs.service'

  import description from '../../../common/description.vue'

  export default {
    name: 'player',
    components: { description },
    computed: {
      playerId() {
        return this.$route.params.playerId;
      },
      player() {
        return state.editPlayer.get();
      }
    },
    async mounted() {
      await playerService.load(this.playerId);
      breadcrumbsService.dynamic.set({ key: "player", func: () => this.player.username });
    },
    beforeDestroy() {
      state.editPlayer.unset();
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/players/player/index.vue